import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import PersonFactory from "../../Entity/Factories/PersonFactory";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";

class PersonUpdate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const person: PersonInterface = PersonFactory.create(props.res);

    this.props.dispatch({
      type: Constants.PAGE_CONTACT_PERSON_UPDATE_SUCCESS,
      payload: {
        person: person
      }
    });
  }

}

export { PersonUpdate };
